import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./cookie-policy-table.module.css";
const isThirdParty = (index, thirdPartyCol)=>index === 1 && thirdPartyCol.toLowerCase() === "3rd party";
export const CookiePolicyTable = ({ table , dontShowTableHeader  })=>{
    const head = table.thead.filter((head, index)=>index !== 2);
    const body = table.tbody;
    return /*#__PURE__*/ _jsxs("table", {
        className: styles.table,
        "data-testid": "cookie-policy-table",
        children: [
            !dontShowTableHeader && /*#__PURE__*/ _jsx("thead", {
                children: /*#__PURE__*/ _jsx("tr", {
                    children: head.map((heading)=>/*#__PURE__*/ _jsx("th", {
                            children: heading.value
                        }, heading._uid))
                })
            }),
            /*#__PURE__*/ _jsx("tbody", {
                children: body.map((row, rowIndex)=>/*#__PURE__*/ _jsx("tr", {
                        children: row.body.filter((cell, index)=>index !== 2).map((cell, index)=>isThirdParty(index, `${row.body[3].value}`) ? /*#__PURE__*/ _jsx("td", {
                                children: /*#__PURE__*/ _jsx("a", {
                                    href: row.body[2].value,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: cell.value
                                })
                            }, cell._uid) : /*#__PURE__*/ _jsx("td", {
                                children: cell.value
                            }, cell._uid))
                    }, row._uid))
            })
        ]
    });
};
